import React from 'react';
import { Button, Text, Flex } from '@chakra-ui/react';
import CustomModal from './CustomModal';

interface DeleteConfirmationModalProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
	isDeleting?: boolean;
	title?: string;
	itemName?: string;
	itemType?: string;
	confirmButtonText?: string;
	confirmButtonColorScheme?: string;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
	isOpen,
	onClose,
	onConfirm,
	isDeleting = false,
	title = 'Delete Item',
	itemName,
	itemType = 'item',
	confirmButtonText = 'Delete',
	confirmButtonColorScheme = 'secondary',
}) => {
	return (
		<CustomModal
			isOpen={isOpen}
			onClose={onClose}
			header={title}
			size="md"
			footer={
				<Flex
					direction={{ base: 'column-reverse', md: 'row' }}
					gap={{ base: 3, md: 3 }}
					width="100%"
				>
					<Button
						variant="outline"
						onClick={onClose}
						disabled={isDeleting}
						flex={1}
						w={{ base: 'full', md: 'auto' }}
					>
						Cancel
					</Button>
					<Button
						colorScheme={confirmButtonColorScheme}
						onClick={onConfirm}
						isLoading={isDeleting}
						loadingText={`${confirmButtonText.slice(0, -1)}ing...`}
						flex={1}
						w={{ base: 'full', md: 'auto' }}
					>
						{confirmButtonText}
					</Button>
				</Flex>
			}
		>
			<Text color="gray.600" lineHeight="1.5">
				Are you sure you want to delete{' '}
				{itemName ? `the ${itemType} "${itemName}"` : `this ${itemType}`}?
			</Text>
		</CustomModal>
	);
};

export default DeleteConfirmationModal;
